import { Component, Input, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import pdfMake from 'pdfmake/build/pdfmake';
import domtoimage from 'dom-to-image';
import { MeasureService } from 'src/app/modules/measure/measure.service';
import { DateTimePipe } from '../../pipe/date.pipe';
import { map } from 'rxjs/operators';

@Component({
  selector: 'lifedi-report-spider',
  templateUrl: './report-spider.component.html',
  styleUrls: ['./report-spider.component.scss'],
})
export class ReportSpiderComponent implements OnInit {
  @Input() measureid: string;
  @Input() type: string;
  @Input() view_status: number;
  @Input() access_id: string;
  @Input() informant_type: string;

  isLoading: boolean;
  data_report;
  // data_report = [
  //   {
  //     reportname: 'รายงานแบบทดสอบ',
  //     measure_name: 'แบบทดสอบพัฒนา',
  //     report_description: 'คำอธิบายรายงานแบบทดสอบ',
  //     max: 10,
  //     data: [
  //       {
  //         group_name: 'ชื่อกลุ่ม',
  //         group_color: '#FF007F',
  //         value: [4, 2, 3],
  //         psy_data: [
  //           {
  //             psy_name: 'ด้านที่111',
  //             psy_description: 'คำอธิบายลักษณะทางจิตวิทยา',
  //             value: '4',
  //             range: '3-5',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //           },
  //           {
  //             psy_name: 'Fairness222',
  //             psy_description: 'คำอธิบายลักษณะทางจิตวิทยา',
  //             range: '3-5',
  //             value: '2',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //           },
  //           {
  //             psy_name: 'Fairness3',
  //             psy_description: 'คำอธิบายลักษณะทางจิตวิทยา',
  //             range: '3-5',
  //             value: '3',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //           },
  //         ],
  //       },
  //       {
  //         group_name: 'ชื่อกลุ่ม2',
  //         group_color: '#40559F',
  //         value: [0, 0, 3, 2, 6], // กลุ่มที่ไม่ใช่กลุ่มแรก ใส่ค่าสุดท้ายของกลุ่มแรกด้วย
  //         psy_data: [
  //           {
  //             psy_name: 'Fairness44',
  //             psy_description: 'คำอธิบายลักษณะทางจิตวิทยา',
  //             range: '3-5',
  //             value: '2',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //           },
  //           {
  //             psy_name: 'Fairness55',
  //             psy_description: 'คำอธิบายลักษณะทางจิตวิทยา',
  //             range: '6-10',
  //             value: '6',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //           },
  //         ],
  //       },
  //       {
  //         group_name: 'ชื่อกลุ่ม3',
  //         group_color: '#59C3C3',
  //         value: [4, 0, 0, 0, 6, 7, 8], // ถ้ากลุ่มสุดท้ายใส่ค่าแรกสุดด้วย
  //         psy_data: [
  //           {
  //             psy_name: 'Fairness66',
  //             psy_description: 'คำอธิบายลักษณะทางจิตวิทยา',
  //             range: '6-10',
  //             value: '7',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //           },
  //           {
  //             psy_name: 'Fairness77',
  //             psy_description: 'คำอธิบายลักษณะทางจิตวิทยา',
  //             range: '6-10',
  //             value: '8',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // ];

  constructor(private measureService: MeasureService) { }

  ngOnInit(): void {
    Chart.register(...registerables);

    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
    let body;

    if (this.access_id) {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        ACCESS_ID: this.access_id,
        INFORMANT_TYPE: this.informant_type,
      };
    } else {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        INFORMANT_TYPE: this.informant_type,
      };
    }
    this.measureService
      .getReportByMeasureId(body)
      .pipe(
        map((res) => {
          this.data_report = [res.result];

          // console.log(this.data_report);

          let allgroups = this.data_report[0].data;
          // console.log(allgroups);

          let alllabels = [];
          let datasets = [];
          for (let i = 0; i < allgroups.length; i++) {
            datasets.push({
              data: allgroups[i].values,
              label: allgroups[i].group_name,
              backgroundColor: allgroups[i].group_color + '80',
              fill: true,
              borderColor: 'transparent',
              pointRadius: 0,
            });
            for (let j = 0; j < allgroups[i].psy_data.length; j++) {
              alllabels.push(allgroups[i].psy_data[j].psy_name);
            }
          }

          const adjustPadding = (label) => {
            let pad;
            // console.log(label);
            if (alllabels.length > 25) {
              let all_lb: number = alllabels.length,
                last_index: number = all_lb - 1,
                half: number = all_lb / 2,
                half_index: number = parseInt(half.toFixed(0)),
                half_before1: number = half_index - 1,
                half_before2: number = half_index - 2,
                half_after1: number = half_index + 1;

              switch (label.index) {
                case 0: pad = 30; break;
                case 1: pad = 20; break;
                case half_before2: pad = 20; break;
                case half_before1: pad = 30; break;
                case half_index: pad = 30; break;
                case half_after1: pad = 20; break;
                case last_index: pad = 20; break;
                default: pad = 10; break;
              }

            } else {
              pad = 10
            }

            return pad
          }

          let myChart1 = new Chart('RadarChartpdf', {
            type: 'radar',
            data: {
              labels: alllabels,
              datasets: datasets,
            },
            options: {
              font: {
                family: 'Sarabun',
              },
              color: '#000',
              devicePixelRatio: 4,
              responsive: true,
              scales: {
                r: {
                  suggestedMax: this.data_report[0].max,
                  beginAtZero: true,
                  pointLabels: {
                    font: {
                      size: 6,
                    },
                    color: '#000',
                    padding: adjustPadding,
                  }
                },
                y: {
                  display: false,
                },
                ticks: {
                  beginAtZero: true,
                  display: false,
                },
              },
              plugins: {
                legend: {
                  labels: {
                    // This more specific font property overrides the global property
                    font: {
                      family: 'Sarabun',
                    },
                  },
                },
              },
            },
          });

          let myChart2 = new Chart('RadarChart', {
            type: 'radar',
            data: {
              labels: alllabels,
              datasets: datasets,
            },
            options: {
              font: {
                family: 'Sarabun',
              },
              color: '#000',
              devicePixelRatio: 4,
              responsive: true,
              scales: {
                r: {
                  suggestedMax: this.data_report[0].max,
                  beginAtZero: true,
                  pointLabels: {
                    font: {
                      size: 8,
                    },
                    padding: adjustPadding,
                    color: '#000',
                  }
                },
                y: {
                  display: false,
                },
                ticks: {
                  beginAtZero: true,
                  display: false,
                },
              },
              plugins: {
                legend: {
                  labels: {
                    // This more specific font property overrides the global property
                    font: {
                      family: 'Sarabun',
                    },
                  },
                },
              },
            },
          });
          this.isLoading = true;
          setTimeout(() => {
            this.filepdf();
            this.isLoading = false;
          }, 4000);
        })
      )
      .subscribe();
  }


  downloadpdf() {
    let formattedDate = new DateTimePipe().transform(
      this.data_report[0].done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report[0].user_id;
    let username = this.data_report[0].username;
    this.isLoading = true;
    const scale = 2;
    let myArray = [document.getElementById('RadarChartpdf')];
    Promise.all(myArray.map((node) => domtoimage.toPng(node, {
      quality: 1,
      width: node.clientWidth * scale,
      height: node.clientHeight * scale,
    }
    ))).then(
      (dataArray) => {
        dataArray[0];
        var img = new Image();
        img.src = dataArray[0];

        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };
        const allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text: username + ' ( userid : ' + userid + ' )' + '  | ' + formattedDate + ' หน้า ' + currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report[0].reportname,
              alignment: 'center',
              fontSize: 24,
              decoration: '',
              color: '#060e9f',
              margin: [0, 10],
              pageBreak: '',
              bold: true,
            },
            {
              text: this.data_report[0].measure_name,
              alignment: 'left',
              fontSize: 22,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].report_description,
              width: '*',
              fontSize: 16,
              margin: [0, 0, 0, 5],
            },
            {
              image: dataArray[0],
              width: 570,
              alignment: 'center',
              margin: [0, 50, 0, 10],
            },
          ],
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };

        let allgroups = this.data_report[0].data;
        // console.log(allgroups);

        for (let i = 0; i < allgroups.length; i++) {
          allPage.content.push({
            text: allgroups[i].group_name,
            alignment: 'center',
            fontSize: 20,
            color: allgroups[i].group_color,
            margin: [0, 30, 0, 0],
            decoration: 'underline',
            pageBreak: 'before',
            bold: true,
          });
          for (let j = 0; j < allgroups[i].psy_data.length; j++) {
            // console.log(allgroups[i].group_color);

            allPage.content.push(
              {
                text: allgroups[i].psy_data[j].psy_name,
                alignment: 'left',
                fontSize: 18,
                decoration: 'underline',
                color: allgroups[i].group_color,
                margin: [0, 20, 0, 0],
                pageBreak: '',
                bold: true,
              },
              {
                text: allgroups[i].psy_data[j].psy_description,
                alignment: 'left',
                fontSize: 14,
                decoration: '',
                color: '#000000',
                margin: [0, 10, 0, 0],
                pageBreak: '',
                bold: false,
              },
              {
                text:
                  'ท่านได้ ' +
                  parseFloat(allgroups[i].psy_data[j].value).toFixed(2) +
                  ' คะแนน',
                alignment: 'left',
                fontSize: 18,
                color: allgroups[i].group_color,
                margin: [0, 5, 0, 0],
                pageBreak: '',
                bold: true,
                decoration: '',
              },
              {
                text: allgroups[i].psy_data[j].range_description,
                alignment: 'left',
                fontSize: 14,
                color: '#000000',
                margin: [0, 10, 0, 10],
                pageBreak: '',
                bold: false,
                decoration: '',
              },
              {
                text: '_____________________________________________________________________________________________',
                alignment: 'center',
                fontSize: 10,
                color: 'gray',
                margin: [0, 10, 0, 0],
                pageBreak: '',
                bold: false,
                decoration: '',
              }
            );
          }
        }
        pdfMake.createPdf(allPage).open();
        this.isLoading = false;
      }
    );
  }
  filepdf() {
    let formattedDate = new DateTimePipe().transform(
      this.data_report[0].done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report[0].user_id;
    const scale = 2;

    let myArray = [document.getElementById('RadarChartpdf')];
    Promise.all(myArray.map((node) => domtoimage.toPng(node,
      {
        quality: 1,
        width: node.clientWidth * scale,
        height: node.clientHeight * scale,
      }
    )
    )).then(
      (dataArray) => {
        dataArray[0];
        var img = new Image();
        img.src = dataArray[0];

        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };
        const allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text:
                  userid +
                  ' | ' +
                  formattedDate +
                  ' หน้า ' +
                  currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report[0].reportname,
              alignment: 'center',
              fontSize: 24,
              decoration: '',
              color: '#060e9f',
              margin: [0, 10],
              pageBreak: '',
              bold: true,
            },
            {
              text: this.data_report[0].measure_name,
              alignment: 'left',
              fontSize: 22,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].report_description,
              width: '*',
              fontSize: 16,
              margin: [0, 0, 0, 5],
            },
            {
              image: dataArray[0],
              width: 570,
              alignment: 'center',
              margin: [0, 50, 0, 10],
            },
          ],
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };

        let allgroups = this.data_report[0].data;
        // console.log(allgroups);

        for (let i = 0; i < allgroups.length; i++) {
          allPage.content.push({
            text: allgroups[i].group_name,
            alignment: 'center',
            fontSize: 20,
            color: allgroups[i].group_color,
            margin: [0, 30, 0, 0],
            decoration: 'underline',
            pageBreak: 'before',
            bold: true,
          });
          for (let j = 0; j < allgroups[i].psy_data.length; j++) {
            // console.log(allgroups[i].group_color);

            allPage.content.push(
              {
                text: allgroups[i].psy_data[j].psy_name,
                alignment: 'left',
                fontSize: 18,
                decoration: 'underline',
                color: allgroups[i].group_color,
                margin: [0, 20, 0, 0],
                pageBreak: '',
                bold: true,
              },
              {
                text: allgroups[i].psy_data[j].psy_description,
                alignment: 'left',
                fontSize: 14,
                decoration: '',
                color: '#000000',
                margin: [0, 10, 0, 0],
                pageBreak: '',
                bold: false,
              },
              {
                text:
                  'ท่านได้ ' +
                  parseFloat(allgroups[i].psy_data[j].value).toFixed(2) +
                  ' คะแนน',
                alignment: 'left',
                fontSize: 18,
                color: allgroups[i].group_color,
                margin: [0, 5, 0, 0],
                pageBreak: '',
                bold: true,
                decoration: '',
              },
              {
                text: allgroups[i].psy_data[j].range_description,
                alignment: 'left',
                fontSize: 14,
                color: '#000000',
                margin: [0, 10, 0, 10],
                pageBreak: '',
                bold: false,
                decoration: '',
              },
              {
                text: '_____________________________________________________________________________________________',
                alignment: 'center',
                fontSize: 10,
                color: 'gray',
                margin: [0, 10, 0, 0],
                pageBreak: '',
                bold: false,
                decoration: '',
              }
            );
          }
        }

        var pdfDocGenerator = pdfMake.createPdf(allPage);
        pdfDocGenerator.getBase64((base64str) => {
          // console.log(base64str);
          let data = {
            MEASURE_ID: this.measureid,
            TYPE: this.type,
            base64str: base64str,
            view: this.view_status,
          };
          this.measureService.SaveReportMeasureId(data).subscribe((res) => {
            // console.log(res);
          });
        });
      }
    );
  }
}
